import React from 'react'
import { Box, BoxProps } from 'rebass/styled-components'

export const Item = ({ children, sx, ...props }: BoxProps): JSX.Element => (
  <Box
    as="li"
    sx={{ display: 'inline-block', mr: '15px', lineHeight: 1, '&:last-of-type': { mr: 0 }, ...sx }}
    {...props}
  >
    {children}
  </Box>
)
